import { useEffect, useState } from 'react';
import { SwitchButtonProps } from './types';

export const SwitchButton = ({
  items = [],
  isDisabled = false,
  selectedValue,
  onClick,
  isLoading,
}: SwitchButtonProps) => {
  const [switchValue, setSwitchValue] = useState(selectedValue);

  useEffect(() => {
    setSwitchValue(selectedValue);
  }, [selectedValue]);

  return (
    <div
      className={
        'bg-white rounded-2xl w-auto p-0.5 mx-auto inline-flex flex-row'
      }
    >
      {items.map((item, index) => (
        <div
          className={`flex rounded-2xl font-semibold h-8 w-24 text-center cursor-pointer justify-center
        items-center
            ${
              item.value === switchValue
                ? 'bg-black text-white'
                : 'bg-white text-black'
            }
            ${isDisabled ? 'opacity-10 cursor-not-allowed' : 'cursor-pointer'}
            `}
          key={'switch-' + item.value + index}
          onClick={() => {
            if (isDisabled) {
              return;
            }

            setSwitchValue(item.value);
            if (onClick) {
              onClick(item.value);
            }
          }}
        >
          {isLoading && item.value === switchValue ? (
            <div
              className={`
              
            `}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                height="16"
                width="16"
                className="fill-current"
              >
                <g className="nc-icon-wrapper" stroke="none">
                  <g className="nc-loop-dots-4-16-icon-f">
                    <circle cx="3" cy="8" r="2"></circle>
                    <circle cx="8" cy="8" r="2" data-color="color-2"></circle>
                    <circle cx="13" cy="8" r="2"></circle>
                  </g>
                </g>
              </svg>
            </div>
          ) : (
            item.label
          )}
        </div>
      ))}
    </div>
  );
};
